import { Schema, locId } from './common_schema.js';

const id = Schema.Int;
const headline = Schema.String;
const text = Schema.String;
const date = Schema.Or(Schema.Date, null);
const dateIsApproximate = Schema.Boolean;
const ratings = Schema.Array(
  Schema.List(
    Schema.String,
    Schema.Or(Schema.Int, Schema.Boolean, Schema.String)
  )
);
const pics = Schema.Array(Schema.String);

const schema = {
  'add-review': new Schema({
    locId,
    headline,
    text,
    date,
    dateIsApproximate,
    ratings,
    pics,
  }),
  'change-review': new Schema({
    id,
    locId,
    headline,
    text,
    date,
    dateIsApproximate,
    ratings,
    pics,
  }),
  'delete-review': new Schema({
    id,
  }),
  'get-reviews': new Schema({
    locId,
  }),
  'get-ratings': new Schema({
    locId,
  }),
};

const schemaFields = {
  id,
  locId,
  headline,
  text,
  date,
  dateIsApproximate,
  pics,
  ratings,
};

export { schema as ReviewSchema, schemaFields as ReviewSchemaFields };
